//* Main
import React, { createContext, Component } from 'react'
import { withRouter } from 'next/router'

//* Helpers
import { api, config, setCookie, removeCookie, asyncFunctionDecorator, checkUserRedirection } from 'helpers'

const UserContext = createContext(null)

class UserProvider extends Component {
    state = {
        ...this.props.userProps,
    }

    methods = {
        login: this.login.bind(this),
        logout: this.logout.bind(this),
        register: this.register.bind(this),
        forgotPassword: this.forgotPassword.bind(this),
        resetPassword: this.resetPassword.bind(this),
        updateAccount: this.updateAccount.bind(this),
        updateAddresses: this.updateAddresses.bind(this),
        changePassword: this.changePassword.bind(this),
    }

    componentDidUpdate(prevProps) {
        if (prevProps.router.asPath !== this.props.router.asPath) {
            checkUserRedirection({
                lang: this.props.router.locale,
                user: this.state.user,
                ctx: this.props.router,
                redirectAutomatically: true,
            })
        }
    }

    login(data) {
        return asyncFunctionDecorator(() =>
            api.post('login', data).then(({ accessToken, user }) => {
                setCookie('accessToken', accessToken)
                this.setState(
                    {
                        isLoggedIn: true,
                        user,
                    },
                    () => {
                        this.props.router.push(config.routes.account.path)
                    }
                )
            })
        )
    }

    logout() {
        return asyncFunctionDecorator(() =>
            api.post('logout').then(() => {
                removeCookie('accessToken')

                this.setState(
                    {
                        isLoggedIn: false,
                        user: null,
                    },
                    () => {
                        this.props.router.push('/')
                    }
                )
            })
        )
    }

    register(data) {
        return asyncFunctionDecorator(() => api.post('register', data))
    }

    forgotPassword(data) {
        return asyncFunctionDecorator(() => api.post('forgot-password', data))
    }

    resetPassword(data) {
        return asyncFunctionDecorator(() => api.post('reset-password', data))
    }

    updateAccount(data) {
        return asyncFunctionDecorator(() => api.post('update-account', data))
    }

    updateAddresses(data) {
        return asyncFunctionDecorator(() => api.post('update-addresses', data)).then(({ customer }) => {
            this.setState(
                {
                    isLoggedIn: true,
                    user: customer,
                }
            )
        })
    }

    changePassword(data) {
        return asyncFunctionDecorator(() => api.post('update-password', data))
    }

    render() {
        return (
            <>
                <UserContext.Provider value={{ ...this.state, ...this.methods }}>{this.props.children}</UserContext.Provider>
            </>
        )
    }
}

export default withRouter(UserProvider)
export const UserConsumer = UserContext.Consumer
